// ProjectsList.js
import React, { useState, useEffect } from 'react';
import { FetchProjects } from '../api/projectsService';
import { useGlobalProvider } from '../contexts/GlobalProvider';
import { useAuth } from '../contexts/AuthContext';

const ProjectsList = () => {
    const [items, setItems] = useState([]);
    const { selectedProjectId, loginStatus, selectedHubId, setSelectedProjectId, setSelectedCategoryId, validateProjectSelection } = useGlobalProvider();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { getAccessToken } = useAuth();


    // useEffect to watch for changes in selectedProjectId
    useEffect(() => {
        setSelectedCategoryId(1);
    }, [selectedProjectId,setSelectedProjectId]);

    // clear project on hub switch:
    const [previousHubId, setPreviousHubId] = useState(selectedHubId);
    useEffect(() => {
        if (selectedHubId !== previousHubId && previousHubId !== '') {
            console.log('Hub changed from', previousHubId, 'to', selectedHubId, '- clearing project selection');
            setSelectedProjectId('');
        }
        setPreviousHubId(selectedHubId);
    }, [selectedHubId, previousHubId, setSelectedProjectId]);

    // Function to fetch projects
    const fetchProjects = async () => {
        setLoading(true);
        try {
            const accessToken = await getAccessToken();
            // console.log('Token in project list:', token);
            const projects = await FetchProjects(accessToken, selectedHubId);
            console.log("Projects fetched:",projects);
            // response is on the data object
            if (projects.data && projects.data.length > 0) {
                setItems(projects.data);
                // Validate that the stored project ID still exists in the fetched projects
                validateProjectSelection(projects.data);
            } else {
                console.log("No projects returned from API", projects);
                setItems([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // useEffect to fetch projects when selectedHubId changed OR on initial load
    useEffect(() => {
        if (loginStatus && selectedHubId) {
            fetchProjects();
        }
    }, [selectedHubId, loginStatus]);

    const handleSelectProject = (event) => {
        console.log('Project selected:', event.target.value);
        setSelectedProjectId(event.target.value);
    };

    // Check if the selected project exists in the current items
    const isSelectedProjectValid = selectedProjectId && items.some(project => project.id === selectedProjectId);
    // Show the selected project ID while loading, or if it's valid after loading
    const displayValue = selectedProjectId && (loading || isSelectedProjectValid) ? selectedProjectId : "";

    // Debug logging (can be removed in production)
    // console.log('ProjectsList render:', {
    //     selectedProjectId,
    //     itemsCount: items.length,
    //     isSelectedProjectValid,
    //     displayValue,
    //     loading
    // });

    if (error) {
        return <div>Error loading data: {error}</div>;
    }

    return (
        <div className="select-container">
            {selectedHubId && (
                <select 
                    className="form-select w-100" 
                    value={displayValue} 
                    onChange={handleSelectProject}
                    disabled={loading}
                >
                    <option value="" disabled>
                        {loading ? "Loading projects..." : "Select Project"}
                    </option>
                    {items.map(project => (
                        <option key={project.id} value={project.id}>
                            {project.attributes.name}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};

export default ProjectsList;
